export function dynamicID() {
    return "dynamicID-" + Math.floor(Math.random() * Date.now().toString()); 
}